import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=e74f190c"
import script from "./Swiper.js?vue&type=script&lang=js&external"
export * from "./Swiper.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports